import {
  ContentBlock,
  Heading,
  Stack,
  Strong,
  Columns,
  Column,
  Box,
  Text,
} from 'braid-design-system';
import React from 'react';

import * as styles from './IntroBanner.css';

interface Props {
  title: string;
  text: string;
}

const IntroBanner = ({ title, text }: Props) => (
  <Box paddingTop={['xlarge', 'xlarge', 'none']} background="brandAccent">
    <ContentBlock width="large">
      <Box paddingX={['gutter', 'xlarge']}>
        <Columns collapseBelow="desktop" space="gutter" alignY="center">
          <Column width="1/3">
            <Box textAlign="left">
              <Stack space="xlarge">
                <Heading level="1">
                  <Box>
                    <Strong>{title}</Strong>
                  </Box>
                </Heading>
                <Text size="large">{text}</Text>
              </Stack>
            </Box>
          </Column>
          <Column>
            <Box paddingTop={['none', 'large']}>
              <Box className={styles.introImg} />
            </Box>
          </Column>
        </Columns>
      </Box>
    </ContentBlock>
  </Box>
);

export default IntroBanner;
